import { useEffect } from 'react'
import { useLocation, type Location } from 'react-router-dom'

const ScrollToTop = () => {
    const location = useLocation()
    const state = location.state as { backgroundLocation?: Location } | null
    const effectivePath = state?.backgroundLocation?.pathname ?? location.pathname

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [effectivePath])

    return null
}

export default ScrollToTop
